module.exports = __webpack_public_path__ + "static/media/Trailer-image.b8da8fc4.svg";